import SeasonSponsors from "../../../../src/docs/assets/season-sponsors-2020.png";
import OperaSponsors from "../../../../src/docs/assets/opera-sponsor.png";
import * as React from 'react';
export default {
  SeasonSponsors,
  OperaSponsors,
  React
};